import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import ChequeList from "../../components/Cheque/List/ChequeList";
import { withRouter } from "react-router";

const ChequeListCarContract = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست چک ها",
            to: "/cheque/list/all",
          },
          {
            title: "لیست چک معامله ماشین",
            to: props.history.location.pathname,
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <ChequeList
            car_contract_id={parseInt(props.match.params.id)}
            name={" معامله ماشین " + props.match.params.id}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default withRouter(ChequeListCarContract);
